var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('button',{ref:"collapsible",staticClass:"collapsible",on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }